import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import _get from 'lodash/get';

import Heading from '../../../Heading';
import Button from '../../../Button';

import GiftIcon from '../../../../icons/gift.svg';

import styles from './Sauce.styl';

const cx = classNames.bind(styles);

const Sauce = ({ className, id, variations, name, addToCart, isAdding }) => (
  <div className={cx('Sauce', className)} onClick={() => addToCart(id, _get(variations, '[0].id'))}>
    <figure className={cx('Sauce__image')}>
      <img src={_get(variations, '[0].image_cart', '')} alt="" />
    </figure>
    <div className={cx('Sauce__info')}>
      <Heading className={cx('Sauce__name')} level={5} tagName="div">
        {name}
      </Heading>
      <div className={cx('Sauce__description')}>
        {_get(variations, '[0].size.value')}&nbsp;{_get(variations, '[0].size.unit')}
      </div>
    </div>
    <Button className={cx('Sauce__button')} small isLoading={isAdding}>
      <GiftIcon width={20} height={20} />
    </Button>
  </div>
);

Sauce.defaultProps = {
  className: '',
};

Sauce.propTypes = {
  className: PropTypes.string,
};

export default Sauce;
